export var method = function method(controller, methodName) {
  var method = controller[methodName];

  if (typeof method == 'function') {
    return method;
  } else {
    return function () {};
  }
};
export var composeEventName = function composeEventName(name, controller, eventPrefix) {
  var composedName = name;

  if (eventPrefix === true) {
    composedName = "".concat(controller.identifier, ":").concat(name);
  } else if (typeof eventPrefix === 'string') {
    composedName = "".concat(eventPrefix, ":").concat(name);
  }

  return composedName;
};
export var extendedEvent = function extendedEvent(type, event, detail) {
  var _ref = event || {
    bubbles: true,
    cancelable: true,
    composed: true
  },
      bubbles = _ref.bubbles,
      cancelable = _ref.cancelable,
      composed = _ref.composed;

  if (event) {
    Object.assign(detail, {
      originalEvent: event
    });
  }

  var customEvent = new CustomEvent(type, {
    bubbles: bubbles,
    cancelable: cancelable,
    composed: composed,
    detail: detail
  });
  return customEvent;
};
export function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowWidth = window.innerWidth || document.documentElement.clientWidth;
  var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
  var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
  return vertInView && horInView;
}
export function camelize(value) {
  return value.replace(/(?:[_-])([a-z0-9])/g, function (_, _char) {
    return _char.toUpperCase();
  });
}